<template>
  <div>
    <section class="mainBox">
      <header class="header">
        <div class="logo">logo图标</div>
        <div class="menu">
          <ul>
            <li>主页</li>
            <li>图表</li>
            <li>量化交易</li>
            <li>研究</li>
            <li @click="handelJump(`/privilegeLevel`)">价格</li>
            <li>
              <el-dropdown
                trigger="click"
                :modal-append-to-body="true"
                szie="small"
              >
                <span class="el-dropdown-link">
                  账号中心<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown" class="header-new-dro">
                  <el-dropdown-item>充值</el-dropdown-item>
                  <el-dropdown-item>升级账户</el-dropdown-item>
                  <el-dropdown-item>个人资料</el-dropdown-item>
                  <el-dropdown-item>站内信</el-dropdown-item>
                  <el-dropdown-item>订阅与告警</el-dropdown-item>
                  <el-dropdown-item>转账记录</el-dropdown-item>
                  <el-dropdown-item>提现记录</el-dropdown-item>
                  <el-dropdown-item>消费记录</el-dropdown-item>
                  <el-dropdown-item>联系客服</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </li>
            <li>后台管理</li>
            <li>财务管理</li>
            <li>EN/中文(简)</li>
            <li>深/浅背景</li>
          </ul>
        </div>
      </header>
      <main class="main">
        <section class="homepage">主页</section>
        <section class="chart">
          
           <div class="characters">图表文字</div>
           <div class="thumbnail">缩略图</div>
        </section>
        <section class="quantization">          
            <div class="transactionText">量化交易文字</div>
           <div class="picture">图片</div>
        </section>
        <section>研究</section>
      </main>
      <footer class="footer">
        <ul>
            <li>产品</li>
        </ul>
        <ul>
            <li>研究</li>
        </ul>
        <ul>
            <li>资源</li>
        </ul>
        <ul>
            <li>声明</li>
        </ul>
      </footer>
    </section>
  </div>
</template>

<script>
import Index from "./index.js";
export default {
  mixins: [Index]
};
</script>

<style lang="scss" scoped>
.mainBox {
//   outline: 1px solid red;
  width: 100.8%;
  display: flex;
  flex-direction: column;
//   margin-left: 8px;

  .header {
    height: 60px;
    background: #f5f5f5;
    padding: 0px 50px;
    display: flex;
    align-items: center;
    display: flex;
    justify-content: space-between;
    .logo {
      outline: 1px solid blue;
      height: 100%;
      display: flex;
      align-items: center;
      width: 180px;
      justify-content: center;
    }
    .menu {
      ul {
        display: flex;
        font-size: 14px;
        li {
          padding: 0px 15px;
        }
        li:hover{
          cursor: pointer;
          color: #f7931a;
        } 
      }
    }
  }
  .main {
    // height: 600px;
    background: sandybrown;
    display: flex;
    flex-direction: column;
    width: 100%;
 
 
    section{
    box-sizing: border-box;
    //   flex: 1;
      width: 100%;
      height:600px;
      flex-direction: column;
      background: #f5f5f5;
      border: 1px solid #ccc;
      border-radius: 5px;
      margin: 10px 0px;
    // background: green;
      flex-wrap: wrap;
      padding: 10px 10px;
    }
    .homepage{
        height: 600px;
    }
    .chart{
        display: flex;
        justify-content: space-between;
        padding-left: 80px;
        .characters{
            width: 30%;
            height: 100%;
            outline: 1px solid red;           
        }
        .thumbnail{
            width: 60%;
            height: 100%;
            outline: 1px solid red;    
        }
    }
    .quantization{
        display: flex;
        justify-content: space-between;
        padding-left: 80px;
        .transactionText{
            width: 60%;
            height: 100%;
            outline: 1px solid red;           
        }
        .picture{
            width: 30%;
            height: 100%;
            outline: 1px solid red;    
        }
    }
  }
  .footer {
    height: 230px;
    background: #1a1a1a;
    display: flex;
    justify-content: space-around;
    padding: 50px 50px;
    font-size: 15px;
    
    ul{
        width: 300px;
        height: 100%;
        // background: darkgray;
        text-align: center;
        color: #f5f5f5;
        font-weight: 600;
    }
  }
}
</style>